import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import { firstValueFrom } from 'rxjs';
import { AuthLoginService } from '../pages/login/services/auth-login.service';

export const authLoginGuard: CanActivateFn = async (route, state) => {
  const cookie = inject(CookieService);
  const router = inject(Router);
  const auth = inject(AuthLoginService);

  const token = cookie.getAll()['x-token']
    ? cookie.getAll()['x-token']
    : route.queryParamMap.get('token');

  if (!token) {
    router.navigate(['unauthorized']);
    return false;
  }

  //TODO contraseña
  try {
    const { ok, firstLogin, isOtp } = await firstValueFrom(auth.checkToken());

    if (ok) {
      //TODO Desde aca seteamos quienes tiene que cambiar la contraseña en caso de ser OTP
      if (!firstLogin || isOtp) {
        router.navigate(['change-pass']);
        return false;
      }
      return true;
    } else {
      auth.logout();
      router.navigate(['unauthorized']);
      return false;
    }
  } catch (error) {
    auth.logout();
    router.navigate(['unauthorized']);
    return false;
  }
};
